<template>
    <div v-if="listing.hoursData && listing.hoursData != null && listing.hoursData.type != 3" class="hours-container">
        <h4>Hours of Operation </h4>
        <div class="badge"><fa-icon :icon="['fas', 'clock']" aria-hidden="true"></fa-icon>{{ listing.hoursData.timezone }}</div>

        <div class="badge warning" v-if="listing.hoursData.majorHolidayCondition == 2"><fa-icon :icon="['fas', 'circle-exclamation']" aria-hidden="true"></fa-icon>Hours/services may differ on major holidays</div>
        <div class="badge warning" v-if="listing.hoursData.majorHolidayCondition == 1"><fa-icon :icon="['fas', 'circle-exclamation']" aria-hidden="true"></fa-icon>Closed on major holidays</div>

        <div class="time">
            <div>
                <span class="day">Monday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Monday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Monday') }}</span>
            </div>
        </div>
        <div class="time">
            <div>
                <span class="day">Tuesday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Tuesday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Tuesday') }}</span>
            </div>
        </div>
        <div class="time">
            <div>
                <span class="day">Wednesday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Wednesday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Wednesday') }}</span>
            </div>
        </div>
        <div class="time">
            <div>
                <span class="day">Thursday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Thursday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Thursday') }}</span>
            </div>
        </div>
        <div class="time">
            <div>
                <span class="day">Friday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Friday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Friday') }}</span>
            </div>
        </div>
        <div :class="[{'closed' : getTimeEntry('Saturday').includes('Closed') }, 'time']">
            <div>
                <span class="day">Saturday</span>
            </div>
            <div>
                <span class="message" v-html="getTimeEntry('Saturday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Saturday') }}</span>
            </div>
        </div>
        <div :class="[{'closed' : getTimeEntry('Sunday').includes('Closed') }, 'time']">
            <div> <span class="day">Sunday</span></div>
            <div>
                <span class="message" v-html="getTimeEntry('Sunday')"></span><br />
                <span class="message">{{ getTimeEntryMessage('Sunday') }}</span>
            </div>
        </div>
    </div>
</template>

<script>import script from './ListingHours';
    export default script;</script>

<style lang="less" scoped>
    @import "./ListingHours.less";
</style>
